import React, { useState } from "react";
import {UpOutlined,  DownOutlined} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import Table from "../Table";

type NotificationCardProps = {
    titleIconComponent: React.ReactNode;
    subTitle: string;
    title: string;
    tableData?: any[];
    tableConfig?: any;
    noContent?: boolean;
    redirectUrl?: string;
};

const NotificationCard = ({
    titleIconComponent,
    subTitle,
    title,
    tableData,
    tableConfig,
    noContent = false,
    redirectUrl
}: NotificationCardProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const UpOutIcon =  <UpOutlined style={{ color: '#fff', fontSize: '20px'}}/>;
    const DownOutIcon = <DownOutlined style={{ color: '#fff', fontSize: '20px'}}/>;

    const handleClick = () => {
        if (noContent && redirectUrl) {
            navigate(redirectUrl);
        } else if (!noContent) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className="rounded-lg card-shadow">
            <div
                onClick={handleClick}
                className={`transition-all hover:opacity-90 px-6 py-4 bg-[#DC3832] rounded-t-lg ${!isOpen && 'rounded-b-lg'} ${(noContent && redirectUrl) || !noContent ? 'cursor-pointer' : ''}`}
            >
                <div className="flex flex-row items-center justify-between">
                    <div className="flex items-center mb-[11px]">
                        <p style={{ fontFamily: 'Din Condensed' }} className="ml-2 mr-5 text-3xl font-bold -mb-[11px] text-white">
                            {title}
                        </p>
                        {titleIconComponent}
                    </div>
                    {!noContent && (isOpen ? UpOutIcon : DownOutIcon)}
                </div>
                {
                    subTitle ?
                        <p style={{ fontFamily: 'DIN condensed' }} className="mt-2 text-xl text-white">{subTitle}</p>
                        : null
                }
                <div className={`h-[1px] bg-white mt-4`}/>
            </div>
            {
                isOpen && !noContent ?
                    <div id="skip" className="p-5 bg-white rounded-b-md">
                        <Table
                            data={tableData || []}
                            tableConfig={tableConfig}
                        />
                    </div>
                    : null
            }
        </div>
    );
}

export default NotificationCard;
